// third-party
import { createSlice } from "@reduxjs/toolkit";

// project imports
import http from "../../http-common";
import { dispatch } from "../index";
// ----------------------------------------------------------------------

const initialState = {
  error: null,
  privilegioTodosUsuario: [],
  privilegioOneUsuario: [],
  notificacaoSuccess: [],
  privilegioResponsavies: [],

};

const slice = createSlice({
  name: "privilegios",
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = action.payload;
    },

    getNotificacaosSuccess(state, action) {
      state.notificacaoSuccess = action.payload;
    },


    getPrivilegioTodosUsuario(state, action) {
      state.privilegioTodosUsuario = action.payload;
    },

    getPrivilegioOneUsuario(state, action) {
      state.privilegioOneUsuario = action.payload;   
  },
  getPrivilegioResponsaveis(state, action) {
    state.privilegioResponsavies = action.payload;   
},
}
});

// Reducer
 export default slice.reducer;

// ----------------------------------------------------------------------
export function getAllPrivilegioTodosUsuario(tipoPesquisa, sedeID, userID, tipoActividade) {
  return async () => {
    try {
        const response = await http.get(`/privilegioUsuarios?tipoPesquisa=${tipoPesquisa}&sedeID=${sedeID}&userID=${userID}&tipoActividade=${tipoActividade}`);
        dispatch(slice.actions.getPrivilegioTodosUsuario(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAllPrivilegioOneUsuario(id, tipoPedido, sedeID, usuarioID,privilegio, tipoActividade) {
  return async () => {
    try {
        const response = await http.get(`/privilegioUsuarios/${id}?tipoPedido=${tipoPedido}&sedeID=${sedeID}&usuarioID=${usuarioID}&privilegio=${privilegio}&tipoActividade=${tipoActividade}`);
        dispatch(slice.actions.getPrivilegioOneUsuario(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAllPrivilegioNotificacaoResponsavies(sedeID, privilegio, tipoActividade, tipoPesquisa) {
  return async () => {
    try {
        const response = await http.get(`/privilegioUsuarios/?sedeID=${sedeID}&privilegio=${privilegio}&tipoActividade=${tipoActividade}&tipoPesquisa=${tipoPesquisa}`);
        dispatch(slice.actions.getPrivilegioResponsaveis(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function privilegioGravar(data) {
  return async () => {
    try {
      const response = await http.post("/privilegioUsuarios", data);

      dispatch(slice.actions.getNotificacaosSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function privilegioDelete(id) {
  return async () => {
    try {
      const response = await http.delete(`/privilegioUsuarios/${id}`);
      dispatch(slice.actions.getNotificacaosSuccess("ok"));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

